import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHeadline"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V5H7V11H17V5H15V3H21V5H19V19H21V21H15V19H17V13H7V19H9V21H3V19H5V5H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadline;
